"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7461],{

/***/ 21179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ft": function() { return /* binding */ tenDigitMobileRegex; },
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "yJ": function() { return /* binding */ nameRegex; }
/* harmony export */ });
var emailRegex = "^undefined$|^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$";
var tenDigitMobileRegex = "^\\d{10}$";
var nameRegex = "^[A-Za-z\\s]+$";



/***/ }),

/***/ 27461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gk": function() { return /* binding */ ieltsEliteFormRequiredFields; },
/* harmony export */   "Mn": function() { return /* binding */ detEliteFormRequiredFields; },
/* harmony export */   "OI": function() { return /* binding */ selfPrepJson; },
/* harmony export */   "Yx": function() { return /* binding */ ieltsDemoMasterclassJson2; },
/* harmony export */   "bX": function() { return /* binding */ ieltsDemoMasterclassJson; },
/* harmony export */   "xb": function() { return /* binding */ ieltsEliteJson; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21179);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11403);



var ieltsEliteFormRequiredFields = [
    "ieltsExamType",
    "whatCareerStage",
    "whenIelts",
    "name",
    "emailId",
    "phone",
    "leadSource",
    "signinPurpose",
    "formId",
    "onboardingPurpose",
    "city", 
];
var detEliteFormRequiredFields = [
    "name",
    "emailId",
    "phone",
    "leadSource",
    "signinPurpose",
    "formId",
    "onboardingPurpose",
    "city", 
];
var ieltsEliteJson = {
    form_id: "Ielts Demo Form",
    form_meta: {
        title: "",
        image: ""
    },
    no_of_steps: 7,
    page_distribution: [
        4,
        3
    ],
    is_auto_progressive: true,
    required: ieltsEliteFormRequiredFields,
    fields: [
        {
            question_id: 1,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "ieltsExamType",
            question_text: "What's your IELTS Type?",
            options: [
                {
                    label: "General",
                    value: "GENERAL"
                },
                {
                    label: "Academic",
                    value: "ACADEMIC"
                },
                {
                    label: "Not Sure",
                    value: "OTHER"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 2,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whatCareerStage",
            question_text: "What are you currently doing?",
            options: [
                {
                    label: "Student",
                    value: "STUDENT"
                },
                {
                    label: "Working",
                    value: "WORKING"
                },
                {
                    label: "Recently graduated",
                    value: "RECENTLY_GRADUATED"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 3,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whenIelts",
            question_text: "When are you giving IELTS?",
            options: [
                {
                    label: "Within 3 months",
                    value: "WITHIN_3_MONTHS"
                },
                {
                    label: "Within 3-6 months",
                    value: "WITHIN_3_6_MONTHS"
                },
                {
                    label: "Already Booked",
                    value: "BOOKED_EXAM"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 7,
            label: "Search your City",
            type: "searchInput",
            fieldValue: "city",
            question_text: "Select your Current City",
            default_visibility: true,
            fetchSuggestions: function(query) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .fetchCityApi */ .JE)(query);
            },
            defaultSuggestions: [
                "Bengaluru, Karnataka",
                "Chennai, Tamil Nadu",
                "Hyderabad, Telangana",
                "Mumbai, Maharashtra",
                "Pune, Maharashtra",
                "Delhi, Delhi",
                "Kolkata, West Bengal",
                "Gurugram, Haryana", 
            ]
        },
        {
            question_id: 4,
            label: "Name*",
            type: "textInput",
            fieldValue: "name",
            question_text: "Enter your details to book IELTS MasterClass",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .nameRegex */ .yJ,
                errorMessage: "Enter correct name"
            }
        },
        {
            question_id: 5,
            label: "Email Address*",
            type: "textInput",
            fieldValue: "emailId",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .emailRegex */ .HN,
                errorMessage: "Please enter correct email"
            }
        },
        {
            question_id: 6,
            label: "Phone Number*",
            type: "textInput",
            fieldValue: "phone",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .tenDigitMobileRegex */ .Ft,
                errorMessage: "please enter correct number"
            }
        }, 
    ]
};
var ieltsDemoMasterclassJson = {
    form_id: "Ielts Demo Form",
    form_meta: {
        title: {},
        image: ""
    },
    no_of_steps: 7,
    page_distribution: [
        4,
        3
    ],
    is_auto_progressive: true,
    required: ieltsEliteFormRequiredFields,
    fields: [
        {
            question_id: 1,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "ieltsExamType",
            question_text: "What's your IELTS Type?",
            options: [
                {
                    label: "General",
                    value: "GENERAL"
                },
                {
                    label: "Academic",
                    value: "ACADEMIC"
                },
                {
                    label: "Not Sure",
                    value: "OTHER"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 2,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whatCareerStage",
            question_text: "What are you currently doing?",
            options: [
                {
                    label: "Student",
                    value: "STUDENT"
                },
                {
                    label: "Working",
                    value: "WORKING"
                },
                {
                    label: "Recently graduated",
                    value: "RECENTLY_GRADUATED"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 3,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whenIelts",
            question_text: "When are you giving IELTS?",
            options: [
                {
                    label: "Within 3 months",
                    value: "WITHIN_3_MONTHS"
                },
                {
                    label: "Within 3-6 months",
                    value: "WITHIN_3_6_MONTHS"
                },
                {
                    label: "Already Booked",
                    value: "BOOKED_EXAM"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 7,
            label: "Search your City",
            type: "searchInput",
            fieldValue: "city",
            question_text: "Select your Current City",
            default_visibility: true,
            fetchSuggestions: function(query) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .fetchCityApi */ .JE)(query);
            },
            defaultSuggestions: [
                "Bengaluru, Karnataka",
                "Chennai, Tamil Nadu",
                "Hyderabad, Telangana",
                "Mumbai, Maharashtra",
                "Pune, Maharashtra",
                "Delhi, Delhi",
                "Kolkata, West Bengal",
                "Gurugram, Haryana", 
            ]
        },
        {
            question_id: 4,
            label: "Name*",
            type: "textInput",
            fieldValue: "name",
            question_text: "Enter your details to book IELTS MasterClass",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .nameRegex */ .yJ,
                errorMessage: "Enter correct name"
            }
        },
        {
            question_id: 5,
            label: "Email Address*",
            type: "textInput",
            fieldValue: "emailId",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .emailRegex */ .HN,
                errorMessage: "Please enter correct email"
            }
        },
        {
            question_id: 6,
            label: "Phone Number*",
            type: "textInput",
            fieldValue: "phone",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .tenDigitMobileRegex */ .Ft,
                errorMessage: "please enter correct number"
            }
        }, 
    ]
};
var ieltsDemoMasterclassJson2 = {
    form_id: "Ielts Demo Form",
    form_meta: {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center md:mb-[-20px] px-6 md:px-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "font-bold md:text-[20px] text-[#0A0926] mb-4",
                    children: "\uD83C\uDF89 Almost done"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[14px] md:text-[16px] text-[#686868] mb-4 md:mb-6 text-center",
                    children: "Just a few more details to give you a personalised session"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "bg-[#DDDDDD] h-[1px] w-full"
                })
            ]
        }),
        image: ""
    },
    no_of_steps: 6,
    page_distribution: [
        3,
        3
    ],
    is_auto_progressive: true,
    required: ieltsEliteFormRequiredFields,
    fields: [
        {
            question_id: 1,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "ieltsExamType",
            question_text: "What's your IELTS Type?",
            options: [
                {
                    label: "General",
                    value: "GENERAL"
                },
                {
                    label: "Academic",
                    value: "ACADEMIC"
                },
                {
                    label: "Not Sure",
                    value: "OTHER"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 2,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whatCareerStage",
            question_text: "What are you currently doing?",
            options: [
                {
                    label: "Student",
                    value: "STUDENT"
                },
                {
                    label: "Working",
                    value: "WORKING"
                },
                {
                    label: "Recently graduated",
                    value: "RECENTLY_GRADUATED"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 3,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whenIelts",
            question_text: "When are you giving IELTS?",
            options: [
                {
                    label: "Within 3 months",
                    value: "WITHIN_3_MONTHS"
                },
                {
                    label: "Within 3-6 months",
                    value: "WITHIN_3_6_MONTHS"
                },
                {
                    label: "Already Booked",
                    value: "BOOKED_EXAM"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 4,
            label: "Name*",
            type: "textInput",
            fieldValue: "name",
            question_text: "Enter your details to book IELTS MasterClass",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .nameRegex */ .yJ,
                errorMessage: "Enter correct name"
            }
        },
        {
            question_id: 5,
            label: "Email Address*",
            type: "textInput",
            fieldValue: "emailId",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .emailRegex */ .HN,
                errorMessage: "Please enter correct email"
            }
        },
        {
            question_id: 6,
            label: "Phone Number*",
            type: "textInput",
            fieldValue: "phone",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .tenDigitMobileRegex */ .Ft,
                errorMessage: "please enter correct number"
            }
        }, 
    ]
};
var selfPrepJson = {
    form_id: "Self Prep Form",
    form_meta: {
        title: "",
        image: ""
    },
    no_of_steps: 6,
    page_distribution: [
        3,
        3
    ],
    is_auto_progressive: true,
    required: ieltsEliteFormRequiredFields,
    fields: [
        {
            question_id: 1,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "ieltsExamType",
            question_text: "What's your IELTS Type?",
            options: [
                {
                    label: "General",
                    value: "GENERAL"
                },
                {
                    label: "Academic",
                    value: "ACADEMIC"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            },
            numGridColumns: 2
        },
        {
            question_id: 2,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whatCareerStage",
            question_text: "What are you currently doing?",
            options: [
                {
                    label: "Student",
                    value: "STUDENT"
                },
                {
                    label: "Working",
                    value: "WORKING"
                },
                {
                    label: "Recently graduated",
                    value: "RECENTLY_GRADUATED"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 3,
            label: "Ielts Type",
            type: "single_select_tile",
            fieldValue: "whenIelts",
            question_text: "When are you giving IELTS?",
            options: [
                {
                    label: "Within 3 months",
                    value: "WITHIN_3_MONTHS"
                },
                {
                    label: "Within 3-6 months",
                    value: "WITHIN_3_6_MONTHS"
                },
                {
                    label: "Already Booked",
                    value: "BOOKED_EXAM"
                }, 
            ],
            default_visibility: true,
            validation: {
                pattern: "",
                errorMessage: ""
            }
        },
        {
            question_id: 4,
            label: "Name*",
            type: "textInput",
            fieldValue: "name",
            question_text: "Enter your details to enroll for Self Prep",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .nameRegex */ .yJ,
                errorMessage: "Enter correct name"
            }
        },
        {
            question_id: 5,
            label: "Email Address*",
            type: "textInput",
            fieldValue: "emailId",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .emailRegex */ .HN,
                errorMessage: "Please enter correct email"
            }
        },
        {
            question_id: 6,
            label: "Phone Number*",
            type: "textInput",
            fieldValue: "phone",
            options: [],
            default_visibility: true,
            visibility_dependency: {
                dependencies: [
                    {
                        question_id: 0,
                        value: []
                    }, 
                ]
            },
            validation: {
                pattern: DataMapper_Common_RegexConstants__WEBPACK_IMPORTED_MODULE_2__/* .tenDigitMobileRegex */ .Ft,
                errorMessage: "please enter correct number"
            }
        }, 
    ]
};


/***/ }),

/***/ 11403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ ieltsFormIds; },
/* harmony export */   "JE": function() { return /* binding */ fetchCityApi; },
/* harmony export */   "LW": function() { return /* binding */ getPageContentForEvent; },
/* harmony export */   "RN": function() { return /* binding */ checkQeFormFilled; },
/* harmony export */   "b8": function() { return /* binding */ demoAliasConstant; },
/* harmony export */   "cY": function() { return /* binding */ getFormId; },
/* harmony export */   "e_": function() { return /* binding */ LeadSources; },
/* harmony export */   "xj": function() { return /* binding */ demoAliasQueryConstant; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var service_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14117);



var ieltsFormIds;
(function(ieltsFormIds) {
    ieltsFormIds["D2C_FORM"] = "D2C Form";
    ieltsFormIds["MOCK_FORM"] = "mock_form";
    ieltsFormIds["DEMO_PROG_FORM"] = "Demo Prog Form";
    ieltsFormIds["IELTS_DEMO_FORM"] = "Ielts Demo Form";
    ieltsFormIds["T2I_FORM"] = "T2I Form";
    ieltsFormIds["IELTS_DEMO_MC_FORM"] = "Ielts Demo MC Form";
})(ieltsFormIds || (ieltsFormIds = {}));
var LeadSources;
(function(LeadSources) {
    LeadSources["MARKETING"] = "Marketing";
    LeadSources["WEB_DASHBOARD"] = "Web Dashboard";
    LeadSources["WEB_DAIGNOSTIC_TESTS"] = "Web Diagnostic Test";
    LeadSources["OTHER"] = "Other";
    LeadSources["ASYNC_DEMO_SCREEN"] = "Async Demo Screen";
    LeadSources["MARKETING_DEMO_MC"] = "Marketing Demo MC";
    LeadSources["SEO_LISTING_PAGE"] = "SEO Listing Page";
    LeadSources["RESCHEDULE_DASHBOARD"] = "Reschedule Dashboard";
    LeadSources["TOFU_DISQUALIFIED_CALENDAR"] = "Tofu Disqualified";
})(LeadSources || (LeadSources = {}));
var getPageContentForEvent = function(currentFormStep) {
    switch(currentFormStep){
        case 1:
            {
                return "Ielts Type";
            }
        case 2:
            {
                return "Career Stage";
            }
        case 3:
            {
                return "Ielts Time";
            }
        case 4:
            {
                return "User Contact Info";
            }
        default:
            {
                return "Ielts Type";
            }
    }
};
var demoAliasQueryConstant = "alias";
var demoAliasConstant = {
    masterclass: "masterclass"
};
var checkQeFormFilled = function(qeFormData) {
    if ((qeFormData === null || qeFormData === void 0 ? void 0 : qeFormData.ieltsExamType) && qeFormData.whatCareerStage && qeFormData.whenIelts && qeFormData.emailId && qeFormData.phone && qeFormData.name) return true;
    return false;
};
var getFormId = function(isDisqualifiedUser, isMasterclassAlias) {
    if (isDisqualifiedUser) return ieltsFormIds.T2I_FORM;
    else {
        if (isMasterclassAlias) return ieltsFormIds.IELTS_DEMO_MC_FORM;
        else return ieltsFormIds.IELTS_DEMO_FORM;
    }
};
var fetchCityApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
        var res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return service_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/api/scholarRoute?path=api/autocomplete?prefix=".concat(query));
                case 3:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data);
                case 8:
                    return _ctx.abrupt("return", []);
                case 9:
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", []);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function fetchCityApi(query) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);